import { render, staticRenderFns } from "./InvoiceClients.vue?vue&type=template&id=cd40953a"
import script from "./InvoiceClients.vue?vue&type=script&lang=js"
export * from "./InvoiceClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports